<template>
  <div class="mb-2 timeline-block" :class="darkMode">
    <span class="timeline-step" :class="darkMode ? 'bg-dark' : ''">
      <i class="text-gradient" :class="`bi bi-${icon} text-${color}`"></i>
    </span>
    <div class="row" style="margin-left: 20px;">
      <div class="col-sm-2">
        <h6 class="mb-0 text-sm font-weight-bold" :class="darkMode ? 'text-white' : 'text-dark'">
          {{ title }}
        </h6>
        <p class="mt-1 mb-0 text-xxs text-secondary font-weight-bold">
          {{ dateTime }}
        </p>
      </div>
      <div class="col-sm-10 mt-2 text-sm" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        {{ description }}
      </div>
    </div>
  </div>
</template>
<script>
import "bootstrap-icons/font/bootstrap-icons.css";
export default {
  name: "TimelineItem",
  props: {
    color: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
      default: () => [],
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
